import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import CommunityRating from "../../community_rating";

export default GrComponentFactory.createClass({
  displayName: "ReviewHeader",

  propTypes: {
    headerText: React.PropTypes.string.isRequired,
    rating: React.PropTypes.number,
    book: GrPropTypes.book().isRequired,
    reviewBodyPresent: React.PropTypes.bool.isRequired,
  },

  renderHeaderWithoutRating() {
    return (
      <a className="gr-hyperlink gr-hyperlink--bold"
        href={this.props.book.bookUrl}>{this.props.book.title}</a>
    );
  },

  renderHeaderWithRating() {
    return (
      <span>
        {this.props.rating > 0 ?
          <CommunityRating
            className="u-inlineBlock"
            rating={this.props.rating}
            size={CommunityRating.ICON_SIZES.MEDIUM}
          />
          : null
        }
      </span>
    );
  },

  render(){
    return (
      <span>
        <span className="gr-newsfeedItem__headerText">
          {this.props.headerText}
        </span>
        {
          this.props.reviewBodyPresent ?
            this.renderHeaderWithoutRating() :
            this.renderHeaderWithRating()
        }
      </span>
    );
  },
});
